import React from "react";
import styled from "styled-components";
import { PieCustomLayerProps } from "@nivo/pie";
import { darkGreen } from "../../styles";

const StyledCenteredText = styled.text<{ isLarge: boolean }>`
  font-size: ${({ isLarge }): number => (isLarge ? 24 : 12)}px;
  font-family: "Apercu";
  color: ${darkGreen};
`;

// Custom component to render in the center of the pie chart
export const CenteredText: React.FC<CustomLayerProps> = ({
  centerX,
  centerY,
  value,
  isLarge,
}) => {
  return (
    <StyledCenteredText
      x={centerX}
      y={isLarge ? centerY - 12 : centerY + 12}
      textAnchor="middle"
      dominantBaseline="central"
      isLarge={isLarge}
    >
      {value}
    </StyledCenteredText>
  );
};

//eslint-disable-next-line
interface CustomLayerProps extends PieCustomLayerProps<any> {
  value: string | number;
  isLarge: boolean;
}

// Factory function to create a custom layer with a specific value
export const createCenteredValueLayer = (
  value: number | string,
  isLarge: boolean,
  /*eslint-disable */
): React.FC<PieCustomLayerProps<any>> => {
  // Define the component inside the factory
  const LayerComponent = (props: PieCustomLayerProps<any>) => (
    <CenteredText
      {...props}
      value={value}
      isLarge={isLarge}
      key={`centered-value-${value}`}
    />
  );
  /*eslint-disable */

  // Assign a displayName to the component for better debugging and tool support
  LayerComponent.displayName = `CenteredValueLayer(${value})`;

  return LayerComponent;
};
